'use client';

import Script from 'next/script';

type BrandContentProps = {
    initializeWebcollage: () => void;
};

export const BrandContentLegacy = ({ initializeWebcollage }: BrandContentProps) => {
    return (
        <Script
            id="webcollage-script"
            src="//scontent.webcollage.net/api/v2/product-content"
            strategy="afterInteractive"
            onLoad={initializeWebcollage}
        />
    );
};
